import {
  fetchRbacPolicy,
  putRbacPolicy,
} from "./rbacApi";

﻿export const ACCESS_POLICY_EVENT = "ipdepot_access_policy_updated";

export const ROLES = [
  {
    key: "admin",
    label: "Administrador",
    description: "Acceso completo al sistema. Este rol permanece bloqueado por seguridad.",
    locked: true,
  },
  {
    key: "empleados",
    label: "Empleados",
    description: "Usuarios operativos con acceso configurable.",
    locked: false,
  },
  {
    key: "provider",
    label: "Provider",
    description: "Proveedores o usuarios externos con acceso configurable.",
    locked: false,
  },
];

export const ACCESS_CATALOG = [
  {
    key: "home.view",
    label: "Inicio",
    description: "Mostrar la pantalla principal del sistema.",
    section: "Operación",
    module: "Inicio",
  },
  {
    key: "equipment.create",
    label: "Crear equipo",
    description: "Registrar equipos nuevos.",
    section: "Operación",
    module: "Altas Operativas",
  },
  {
    key: "inventory.view",
    label: "Consultar inventario de equipos",
    description: "Visualizar el inventario del parque tecnológico.",
    section: "Operación",
    module: "Parque Tecnológico",
  },
  {
    key: "projects.view",
    label: "Consultar centro de control",
    description: "Visualizar y operar la gestión de proyectos.",
    section: "Operación",
    module: "Gestión de Proyectos",
  },
  {
    key: "quotes.view",
    label: "Consultar cotizaciones",
    description: "Visualizar comparativos y cotizaciones.",
    section: "Proveedores y Compras",
    module: "Cotizaciones",
  },
  {
    key: "quotes.create",
    label: "Crear cotización",
    description: "Registrar nuevas cotizaciones.",
    section: "Proveedores y Compras",
    module: "Cotizaciones",
    dependsOn: ["quotes.view"],
  },
  {
    key: "quotes.edit",
    label: "Editar cotización",
    description: "Modificar cotizaciones existentes.",
    section: "Proveedores y Compras",
    module: "Cotizaciones",
    dependsOn: ["quotes.view"],
  },
  {
    key: "quotes.delete",
    label: "Eliminar cotización",
    description: "Eliminar cotizaciones existentes.",
    section: "Proveedores y Compras",
    module: "Cotizaciones",
    dependsOn: ["quotes.view"],
    critical: true,
  },
  {
    key: "supplies.view",
    label: "Consultar insumos",
    description: "Visualizar existencias e información de insumos.",
    section: "Proveedores y Compras",
    module: "Insumos de Producción",
  },
  {
    key: "supplies.request.create",
    label: "Crear solicitud de insumos",
    description: "Registrar solicitudes de abastecimiento.",
    section: "Proveedores y Compras",
    module: "Insumos de Producción",
    dependsOn: ["supplies.view"],
  },
  {
    key: "supplies.stock.capture",
    label: "Capturar stock operativo",
    description: "Capturar existencias operativas reportadas por oficina.",
    section: "Proveedores y Compras",
    module: "Insumos de Producción",
    dependsOn: ["supplies.view"],
  },
  {
    key: "supplies.stock.update",
    label: "Actualizar stock",
    description: "Modificar existencias del inventario de insumos.",
    section: "Proveedores y Compras",
    module: "Insumos de Producción",
    dependsOn: ["supplies.view"],
    critical: true,
  },
  {
    key: "supplies.providerPdf.create",
    label: "Generar PDF de proveedor",
    description: "Crear el documento PDF destinado al proveedor.",
    section: "Proveedores y Compras",
    module: "Insumos de Producción",
    dependsOn: ["supplies.view"],
  },
  {
    key: "folios.view",
    label: "Consultar control de folios",
    description: "Visualizar el módulo de control de folios.",
    section: "Proveedores y Compras",
    module: "Control de Folios",
  },
  {
    key: "shipments.view",
    label: "Consultar remisiones",
    description: "Visualizar remisiones de envío.",
    section: "Proveedores y Compras",
    module: "Remisiones de Envío",
  },
  {
    key: "shipments.create",
    label: "Crear remisión",
    description: "Registrar nuevas remisiones.",
    section: "Proveedores y Compras",
    module: "Remisiones de Envío",
    dependsOn: ["shipments.view"],
  },
  {
    key: "shipments.print",
    label: "Imprimir remisión",
    description: "Generar o imprimir la remisión.",
    section: "Proveedores y Compras",
    module: "Remisiones de Envío",
    dependsOn: ["shipments.view"],
  },
  {
    key: "shipments.deliver",
    label: "Marcar remisión como entregada",
    description: "Cerrar el flujo operativo de la remisión.",
    section: "Proveedores y Compras",
    module: "Remisiones de Envío",
    dependsOn: ["shipments.view"],
    critical: true,
  },
  {
    key: "incidents.view",
    label: "Consultar incidencias",
    description: "Visualizar el listado de incidencias.",
    section: "Soporte Operativo",
    module: "Incidencias",
  },
  {
    key: "incidents.create",
    label: "Reportar incidencia",
    description: "Registrar nuevas incidencias operativas.",
    section: "Soporte Operativo",
    module: "Incidencias",
  },
  {
    key: "evidence.view",
    label: "Consultar evidencias operativas",
    description: "Visualizar reportes y evidencias.",
    section: "Soporte Operativo",
    module: "Evidencias Operativas",
  },
  {
    key: "services.view",
    label: "Consultar servicios y suscripciones",
    description: "Visualizar contratos, telefonía, internet y suscripciones.",
    section: "Gestión",
    module: "Servicios y Suscripciones",
  },
  {
    key: "services.create",
    label: "Agregar servicio",
    description: "Registrar nuevos servicios o suscripciones.",
    section: "Gestión",
    module: "Servicios y Suscripciones",
    dependsOn: ["services.view"],
  },
  {
    key: "services.edit",
    label: "Editar servicio",
    description: "Modificar servicios o suscripciones existentes.",
    section: "Gestión",
    module: "Servicios y Suscripciones",
    dependsOn: ["services.view"],
  },
  {
    key: "personnel.view",
    label: "Consultar directorio de personal",
    description: "Visualizar empleados y responsables.",
    section: "Gestión",
    module: "Directorio de Personal",
  },
  {
    key: "personnel.create",
    label: "Crear empleado",
    description: "Registrar personal nuevo.",
    section: "Gestión",
    module: "Directorio de Personal",
    dependsOn: ["personnel.view"],
  },
  {
    key: "personnel.edit",
    label: "Editar empleado",
    description: "Modificar información del personal.",
    section: "Gestión",
    module: "Directorio de Personal",
    dependsOn: ["personnel.view"],
  },
  {
    key: "credentials.view",
    label: "Consultar credenciales de acceso",
    description: "Visualizar sitios y credenciales registradas.",
    section: "Gestión",
    module: "Credenciales de Acceso",
  },
  {
    key: "credentials.create",
    label: "Crear credencial",
    description: "Registrar una nueva credencial.",
    section: "Gestión",
    module: "Credenciales de Acceso",
    dependsOn: ["credentials.view"],
  },
  {
    key: "credentials.edit",
    label: "Editar credencial",
    description: "Modificar credenciales registradas.",
    section: "Gestión",
    module: "Credenciales de Acceso",
    dependsOn: ["credentials.view"],
  },
  {
    key: "documents.upload",
    label: "Carga documental",
    description: "Cargar archivos al gestor documental.",
    section: "Gestión",
    module: "Gestión Documental",
  },
  {
    key: "documents.archive",
    label: "Archivo documental",
    description: "Consultar carpetas y documentos.",
    section: "Gestión",
    module: "Gestión Documental",
  },
  {
    key: "documents.search",
    label: "Búsqueda OCR",
    description: "Buscar contenido dentro de documentos procesados.",
    section: "Gestión",
    module: "Gestión Documental",
  },
  {
    key: "reports.comparison",
    label: "Carga de reportes",
    description: "Consultar el comparativo de reportes.",
    section: "Reportes",
    module: "Reportes",
  },
  {
    key: "reports.variation",
    label: "Variación ejecutiva",
    description: "Consultar variaciones ejecutivas.",
    section: "Reportes",
    module: "Reportes",
  },
  {
    key: "reports.municipalities",
    label: "Variación por municipio",
    description: "Consultar variaciones por municipio.",
    section: "Reportes",
    module: "Reportes",
  },
  {
    key: "settings.view",
    label: "Consultar configuración",
    description: "Visualizar la configuración general.",
    section: "Administración",
    module: "Configuración",
  },
  {
    key: "access.manage",
    label: "Administrar seguridad y accesos",
    description: "Asignar permisos a Empleados y Provider.",
    section: "Administración",
    module: "Seguridad y Accesos",
    critical: true,
  },
];

export const MODULES = ACCESS_CATALOG.map(({ key, label }) => ({ key, label }));

const ALL_PERMISSION_KEYS = ACCESS_CATALOG.map((permission) => permission.key);
const VALID_PERMISSION_KEYS = new Set(ALL_PERMISSION_KEYS);
const CATALOG_BY_KEY = new Map(
  ACCESS_CATALOG.map((permission) => [permission.key, permission])
);

export const DEFAULT_ACCESS_POLICY = Object.freeze({
  admin: ALL_PERMISSION_KEYS,
  empleados: [
    "home.view",
    "equipment.create",
    "inventory.view",
    "projects.view",
    "supplies.view",
    "incidents.view",
    "incidents.create",
    "evidence.view",
    "services.view",
    "services.create",
    "shipments.view",
    "shipments.create",
    "shipments.print",
  
    "services.edit",],
  provider: [
    "supplies.view",
    "supplies.request.create",
    "shipments.view",
    "shipments.create",
    "shipments.print",
  ],
});

const ROLE_ALIASES = {
  admin: "admin",
  administrador: "admin",
  administradores: "admin",
  empleados: "empleados",
  empleado: "empleados",
  provider: "provider",
  proveedor: "provider",
  proveedores: "provider",
};

const PERMISSION_ALIASES = {
  home: ["home.view"],
  inicio: ["home.view"],

  "equipos.crear": ["equipment.create"],
  agregar: ["equipment.create", "services.create", "credentials.create"],

  "inventario.ver": ["inventory.view"],
  inventario: ["inventory.view"],
  "parque.tecnologico": ["inventory.view"],
  parquetecnologico: ["inventory.view"],
  "parque-tecnologico": ["inventory.view"],
  parque_tecnologico: ["inventory.view"],

  "proyectos.ver": ["projects.view"],
  proyectos: ["projects.view"],

  "cotizaciones.ver": ["quotes.view"],
  "cotizaciones.crear": ["quotes.create"],
  "cotizaciones.editar": ["quotes.edit"],
  "cotizaciones.eliminar": ["quotes.delete"],
  cotizaciones: ["quotes.view"],

  "insumos.manage": ["supplies.view"],
  insumos: ["supplies.view"],

  "remisiones.manage": ["shipments.view"],
  remisiones: ["shipments.view"],

  "incidencias.ver": ["incidents.view"],
  "incidencias.crear": ["incidents.create"],
  incidencias: ["incidents.view"],
  "evidencias.ver": ["evidence.view"],

  "contratos.ver": ["services.view"],
  "contratos.crear": ["services.create"],
  "contratos.editar": ["services.edit"],
  contratos: ["services.view"],
  "servicios.ver": ["services.view"],
  servicios: ["services.view"],
  suscripciones: ["services.view"],
  serviciossuscripciones: ["services.view"],
  servicios_y_suscripciones: ["services.view"],
  "servicios-suscripciones": ["services.view"],
  "servicios-y-suscripciones": ["services.view"],
  "contratos-servicios-suscripciones": ["services.view"],

  "empleados.ver": ["personnel.view"],
  "empleados.crear": ["personnel.create"],
  "empleados.editar": ["personnel.edit"],
  empleados: ["personnel.view"],

  "sitios.ver": ["credentials.view"],
  "sitios.crear": ["credentials.create"],
  "sitios.editar": ["credentials.edit"],
  sitios: ["credentials.view"],

  "documentos.carga": ["documents.upload"],
  "documentos.archivo": ["documents.archive"],
  "documentos.buscar": ["documents.search"],
  documentos: ["documents.upload", "documents.archive", "documents.search"],

  "reportes.comparativo": ["reports.comparison"],
  "reportes.variacion": ["reports.variation"],
  "reportes.municipios": ["reports.municipalities"],
  reportes: ["reports.comparison", "reports.variation", "reports.municipalities"],

  "configuracion.ver": ["settings.view"],
  "configuracion.accesos": ["access.manage"],
  configuracion: ["settings.view", "access.manage"],
};

const ROUTE_RULES = [
  { test: (path) => path === "/" || path === "", permission: "home.view" },
  { test: (path) => path.startsWith("/callback"), public: true },
  { test: (path) => path.startsWith("/logout"), public: true },
  { test: (path) => path.startsWith("/agregar"), permission: "equipment.create" },
  { test: (path) => path.startsWith("/inventario"), permission: "inventory.view" },
  { test: (path) => path.startsWith("/proyectos"), permission: "projects.view" },
  { test: (path) => path.startsWith("/cotizaciones/nueva"), permission: "quotes.create" },
  { test: (path) => path.startsWith("/cotizaciones/editar"), permission: "quotes.edit" },
  { test: (path) => path.startsWith("/cotizaciones"), permission: "quotes.view" },
  { test: (path) => path.startsWith("/insumos-produccion"), permission: "supplies.view" },
  { test: (path) => path.startsWith("/folios"), permission: "folios.view" },
  { test: (path) => path.startsWith("/remisiones-envio/nueva"), permission: "shipments.create" },
  { test: (path) => path.startsWith("/remisiones-envio"), permission: "shipments.view" },
  { test: (path) => path.startsWith("/incidencias/crear"), permission: "incidents.create" },
  { test: (path) => path.startsWith("/incidencias"), permission: "incidents.view" },
  { test: (path) => path.startsWith("/evidencias"), permission: "evidence.view" },
  { test: (path) => path.startsWith("/contratos/agregar"), permission: "services.create" },
  { test: (path) => path.startsWith("/contratos/editar"), permission: "services.edit" },
  {
    test: (path) =>
      path.startsWith("/contratos") ||
      path.startsWith("/servicios-suscripciones") ||
      path.startsWith("/servicios-y-suscripciones") ||
      path.startsWith("/contratos-servicios-suscripciones") ||
      path.startsWith("/servicios") ||
      path.startsWith("/suscripciones"),
    permission: "services.view",
  },
  { test: (path) => path.startsWith("/empleados/nuevo"), permission: "personnel.create" },
  { test: (path) => path.startsWith("/empleados/editar"), permission: "personnel.edit" },
  { test: (path) => path.startsWith("/empleados"), permission: "personnel.view" },
  { test: (path) => path.startsWith("/sitios/nuevo"), permission: "credentials.create" },
  { test: (path) => path.startsWith("/sitios/editar"), permission: "credentials.edit" },
  { test: (path) => path.startsWith("/sitios"), permission: "credentials.view" },
  { test: (path) => path.startsWith("/documentos/carga"), permission: "documents.upload" },
  { test: (path) => path.startsWith("/documentos/archivo"), permission: "documents.archive" },
  { test: (path) => path.startsWith("/documentos/buscar"), permission: "documents.search" },
  { test: (path) => path.startsWith("/documentos"), permission: "documents.archive" },
  { test: (path) => path.startsWith("/reportes/comparativo"), permission: "reports.comparison" },
  { test: (path) => path.startsWith("/reportes/variacion"), permission: "reports.variation" },
  { test: (path) => path.startsWith("/reportes/municipios"), permission: "reports.municipalities" },
  { test: (path) => path.startsWith("/configuracion/accesos"), permission: "access.manage" },
  { test: (path) => path.startsWith("/configuracion"), permission: "settings.view" },
  { test: (path) => path.startsWith("/dev"), permission: "access.manage" },
];

function normalize(value) {
  return String(value || "").toLowerCase().trim();
}

function decodeJwtPayload(token) {
  if (!token || !token.includes(".")) return {};

  try {
    const payload = token.split(".")[1];
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
    const decoded = atob(padded);
    const utf8 = decodeURIComponent(
      decoded
        .split("")
        .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, "0")}`)
        .join("")
    );

    return JSON.parse(utf8);
  } catch {
    return {};
  }
}

function canonicalRole(role) {
  return ROLE_ALIASES[normalize(role)] || normalize(role);
}

function resolvePermissionKeys(value) {
  const key = normalize(value);
  if (!key) return [];
  if (VALID_PERMISSION_KEYS.has(key)) return [key];
  return PERMISSION_ALIASES[key] || [];
}

function addDependencies(permissionKeys) {
  const result = new Set(permissionKeys.filter((key) => VALID_PERMISSION_KEYS.has(key)));
  let changed = true;

  while (changed) {
    changed = false;
    Array.from(result).forEach((key) => {
      const permission = CATALOG_BY_KEY.get(key);
      (permission?.dependsOn || []).forEach((dependency) => {
        if (!result.has(dependency)) {
          result.add(dependency);
          changed = true;
        }
      });
    });
  }

  return Array.from(result);
}

function removeInvalidDependents(permissionKeys) {
  let result = new Set(permissionKeys.filter((key) => VALID_PERMISSION_KEYS.has(key)));
  let changed = true;

  while (changed) {
    changed = false;
    Array.from(result).forEach((key) => {
      const permission = CATALOG_BY_KEY.get(key);
      const missingDependency = (permission?.dependsOn || []).some(
        (dependency) => !result.has(dependency)
      );

      if (missingDependency) {
        result.delete(key);
        changed = true;
      }
    });
  }

  return Array.from(result);
}

export function normalizePermissionList(permissionKeys, options = {}) {
  const { includeDependencies = true } = options;
  const resolved = (Array.isArray(permissionKeys) ? permissionKeys : [])
    .flatMap(resolvePermissionKeys)
    .filter((key) => VALID_PERMISSION_KEYS.has(key));

  const unique = Array.from(new Set(resolved));
  return includeDependencies ? addDependencies(unique) : removeInvalidDependents(unique);
}

export function getTokenPayload() {
  const idPayload = decodeJwtPayload(localStorage.getItem("idToken"));
  const accessPayload = decodeJwtPayload(localStorage.getItem("accessToken"));
  return { ...accessPayload, ...idPayload };
}

export function getUserGroups() {
  const payloads = [
    decodeJwtPayload(localStorage.getItem("idToken")),
    decodeJwtPayload(localStorage.getItem("accessToken")),
  ];

  const groups = new Set();
  payloads.forEach((payload) => {
    const tokenGroups = payload["cognito:groups"];
    if (Array.isArray(tokenGroups)) {
      tokenGroups.forEach((group) => groups.add(canonicalRole(group)));
    }
  });

  return Array.from(groups).filter(Boolean);
}



export function getCurrentRbacUser() {

  return remoteCurrentUser
    ? {
        ...remoteCurrentUser,
      }
    : null;
}

export function getPrimaryRole() {

  if (
    remoteCurrentRole
  ) {

    return remoteCurrentRole;
  }


  const groups =
    getUserGroups();


  if (
    groups.includes(
      "admin"
    )
  ) {

    return "admin";
  }


  if (
    groups.includes(
      "empleados"
    )
  ) {

    return "empleados";
  }


  if (
    groups.includes(
      "provider"
    )
  ) {

    return "provider";
  }


  return null;
}


let remotePolicyCache = null;

let remoteCurrentUser = null;
let remoteCurrentRole = null;
let remoteEffectivePermissions = null;


function normalizePolicyShape(policy) {

  const roles =
    policy?.roles &&
    typeof policy.roles === "object"
      ? policy.roles
      : policy || {};


  return {

    admin: [
      ...ALL_PERMISSION_KEYS,
    ],


    empleados:
      normalizePermissionList(
        Array.isArray(roles.empleados)
          ? roles.empleados
          : DEFAULT_ACCESS_POLICY.empleados
      ),


    provider:
      normalizePermissionList(
        Array.isArray(roles.provider)
          ? roles.provider
          : DEFAULT_ACCESS_POLICY.provider
      ),
  };
}


export function getAccessPolicy() {

  if (remotePolicyCache) {

    return {
      admin: [
        ...remotePolicyCache.admin,
      ],

      empleados: [
        ...remotePolicyCache.empleados,
      ],

      provider: [
        ...remotePolicyCache.provider,
      ],
    };
  }


  return normalizePolicyShape(
    DEFAULT_ACCESS_POLICY
  );
}


export async function loadAccessPolicy() {

  const remote =
    await fetchRbacPolicy();


  remotePolicyCache =
    normalizePolicyShape(
      remote
    );


  remoteCurrentUser =
    remote?.currentUser ||
    null;


  remoteCurrentRole =
    remote?.currentUser?.role ||
    remote?.currentRole?.role ||
    null;


  remoteEffectivePermissions =
    new Set(
      Array.isArray(
        remote?.effectivePermissions
      )
        ? remote.effectivePermissions
        : []
    );


  window.dispatchEvent(
    new CustomEvent(
      ACCESS_POLICY_EVENT,
      {
        detail: {
          source:
            "remote-v52-load",

          role:
            remoteCurrentRole,
        },
      }
    )
  );


  return getAccessPolicy();
}


export async function saveAccessPolicy(
  policy,
  metadata = {}
) {

  const safePolicy =
    normalizePolicyShape(
      policy
    );


  const remote =
    await putRbacPolicy(
      safePolicy
    );


  remotePolicyCache =
    normalizePolicyShape(
      remote
    );


  remoteCurrentUser =
    remote?.currentUser ||
    remoteCurrentUser;


  remoteCurrentRole =
    remote?.currentUser?.role ||
    remote?.currentRole?.role ||
    remoteCurrentRole;


  remoteEffectivePermissions =
    new Set(
      Array.isArray(
        remote?.effectivePermissions
      )
        ? remote.effectivePermissions
        : Array.from(
            remoteEffectivePermissions ||
            []
          )
    );


  window.dispatchEvent(
    new CustomEvent(
      ACCESS_POLICY_EVENT,
      {
        detail: {
          source:
            "remote-v52-save",

          updatedBy:
            metadata.updatedBy ||
            null,
        },
      }
    )
  );


  return getAccessPolicy();
}


export async function resetAccessPolicy(
  role = null
) {

  const current =
    getAccessPolicy();


  if (!role) {

    return saveAccessPolicy({
      admin: [
        ...ALL_PERMISSION_KEYS,
      ],

      empleados: [
        ...DEFAULT_ACCESS_POLICY.empleados,
      ],

      provider: [
        ...DEFAULT_ACCESS_POLICY.provider,
      ],
    });
  }


  const canonical =
    canonicalRole(role);


  if (canonical === "admin") {
    return current;
  }


  const next = {
    ...current,

    [canonical]: [
      ...(
        DEFAULT_ACCESS_POLICY[
          canonical
        ] || []
      ),
    ],
  };


  return saveAccessPolicy(next);
}


export function isAdmin() {

  return (
    getPrimaryRole() ===
    "admin"
  );
}

export function isEmpleado() {

  return (
    getPrimaryRole() ===
    "empleados"
  );
}

export function getEffectivePermissions() {

  const role =
    getPrimaryRole();


  if (
    role === "admin"
  ) {

    return new Set(
      ALL_PERMISSION_KEYS
    );
  }


  if (
    remoteEffectivePermissions
  ) {

    if (
      remoteEffectivePermissions.has(
        "*"
      )
    ) {

      return new Set(
        ALL_PERMISSION_KEYS
      );
    }


    return new Set(
      remoteEffectivePermissions
    );
  }


  const policy =
    getAccessPolicy();


  return new Set(
    policy[role] ||
    []
  );
}

export function canViewModule(moduleName) {
  if (isAdmin()) return true;

  const requested = resolvePermissionKeys(moduleName);
  if (requested.length === 0) return false;

  const effective = getEffectivePermissions();
  return requested.some((permissionKey) => effective.has(permissionKey));
}

export function canAccessPath(pathname) {
  const path = normalize(pathname || "/");
  const rule = ROUTE_RULES.find((candidate) => candidate.test(path));

  if (!rule) return isAdmin();
  if (rule.public) return true;
  return canViewModule(rule.permission);
}

export function getPermissionDefinition(permissionKey) {
  return CATALOG_BY_KEY.get(permissionKey) || null;
}

export function getAllPermissionKeys() {
  return [...ALL_PERMISSION_KEYS];
}

